module.exports = __webpack_public_path__ + "static/media/rps2.fe89fe85.gif";